import * as z from "zod";

export const getSegmentProductVendors = {
  name: "getSegmentProductVendors" as const,
  description:
    "Product vendors this store has, for a vendor condition's values.",
  mutates: false,
  input: z.null(),
  output: z.array(z.string()),
};
